import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
var RemovePhoneConfirmation = /*#__PURE__*/function (_Component) {
  _inherits(RemovePhoneConfirmation, _Component);
  var _super = _createSuper(RemovePhoneConfirmation);
  function RemovePhoneConfirmation(props) {
    var _this;
    _classCallCheck(this, RemovePhoneConfirmation);
    _this = _super.call(this, props);
    _this.onCancel = _this.onCancel.bind(_assertThisInitialized(_this));
    _this.onConfirm = _this.onConfirm.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(RemovePhoneConfirmation, [{
    key: "onCancel",
    value: function onCancel() {
      this.props.onCancel();
    }
  }, {
    key: "onConfirm",
    value: function onConfirm() {
      this.props.onConfirm();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        confirmationMessage = _this$props.confirmationMessage,
        show = _this$props.show,
        styles = _this$props.styles;
      return /*#__PURE__*/React.createElement("div", {
        className: "remove-phone-confirmation row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-md-12 text-right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "remove-button",
        style: show ? styles.showRemove : styles.hideRemove
      }, confirmationMessage, /*#__PURE__*/React.createElement("a", {
        className: "confirm-confirmation",
        onClick: this.onConfirm,
        role: "button",
        tabIndex: 0
      }, "YES"), /*#__PURE__*/React.createElement("a", {
        className: "cancel-confirmation",
        onClick: this.onCancel,
        role: "button",
        tabIndex: 0
      }, "NO"))));
    }
  }]);
  return RemovePhoneConfirmation;
}(Component);
RemovePhoneConfirmation.propTypes = {
  confirmationMessage: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  show: PropTypes.bool,
  styles: PropTypes.object.isRequired
};
RemovePhoneConfirmation.defaultProps = {
  confirmationMessage: 'Are you sure you want to remove this phone number?',
  onCancel: noop,
  onConfirm: noop,
  show: false,
  styles: {
    fadeRemove: {
      opacity: '.3'
    },
    hideRemove: {
      visibility: 'hidden',
      display: 'none'
    },
    showRemove: {
      visibility: 'visible'
    }
  }
};
export default RemovePhoneConfirmation;
//# sourceMappingURL=RemovePhoneConfirmation.js.map